import React from "react";

const Profile: React.FC = () => (
  <div style={{ maxWidth: 800, margin: "0 auto", padding: "32px 24px" }}>
    <h1 style={{ marginTop: 0 }}>Profile</h1>
    <p style={{ color: "#64748b" }}>
      Profile, account settings and organisation info will be built here.
    </p>
  </div>
);

export default Profile;
